/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Acwr_Risk_HighInputs */

const en_ui_acwr_risk_high = /** @type {(inputs: Ui_Acwr_Risk_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High risk`)
};

const de_ui_acwr_risk_high = /** @type {(inputs: Ui_Acwr_Risk_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hohes Risiko`)
};

/**
* | output |
* | --- |
* | "High risk" |
*
* @param {Ui_Acwr_Risk_HighInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_acwr_risk_high = /** @type {((inputs?: Ui_Acwr_Risk_HighInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Acwr_Risk_HighInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_acwr_risk_high(inputs)
	return de_ui_acwr_risk_high(inputs)
});